const translations = {
  cz: {
    urlporadna: '/poradna/',
    precistClanek: 'Přečíst článek',
    vytvoril: 'Vytvořil',
    textporadna: 'Poradna',

    obleceniProZavodText: "KRASOBRUSLAŘSKÁ VÝBAVA",
    obleceniProZavodBenefity: "Vlastní česká značka Icedream * Závodní šaty * Pánská kolekce * Světové značky",
    obleceniProZavodBtnText: "Celá kolekce",
    obleceniProZavodBtnOdkaz: "/#/",

    ledniKrasobrusleText: "Krasobrusle",
    ledniKrasobrusleBenefity: "Profesionální brusle, nože i celé komplety od začátečníků po vrcholové soutěže.",
    ledniKrasobrusleBtnText: "Zobrazit všechny produkty",
    ledniKrasobrusleBtnOdkaz: "/#/",

    telefonInfo: '(PO - PÁ 9:00 - 16:00)',
    mailInfo: 'odpovíme do 48 hodin',

    customLoginText: 'Máte u nás účet? Přihlaste se, údaje se vyplní automaticky.',
    customLoginBtn: 'Přihlásit se',
    vybrat: 'Vybrat z našich produktů',
    pokracovatnaobjednvaku: 'Pokračovat na objednávku',
    nepotrebujete: 'Nepotřebujete něco?',
    produkt: 'Produkt',
    dostupnost: 'Dostupnost',
    pocet: 'Počet',
    cenaZaKus: 'Cena za kus',
    sleva: 'Sleva',
    celkem: 'Celkem',
    odebratkupon: 'Odebrat kupon',
    objednavkaPrijata: 'Objednávka přijata',
    dekujemeZaObjednavku: 'Děkujeme za Vaši objednávku',
    jejiCislo: 'Její číslo: ',
    zdarma: 'Zdarma',
    darekKObjednavce: 'Dárek k objednávce',
    zaKus: '/ ks',

    dalsiProdukty: 'Další produkty',
    parametryProduktu: 'Parametry produktu',
    filtrovat: 'Filtrovat',
    zavritFiltr: 'Zavřít filtr',
    nejprodavanejsiVKategorii: 'Nejprodávanější v této kategorii',
    stitky: 'Štítky',
    seraditDle: 'Seřadit dle',

    dokosiku: 'Do košíku',
    souvisejicividea: 'Související videa',
    parametry: 'Parametry',
    overenyzakaznik:'Ověřený zákazník',
    urlhodnoceni: '/cache/hodnoceni-obchodu/?jsonFormat',
    objednatbrouseni: 'Objednat broušení:',
    az: 'až',
    choosesizes: 'Zvolte velikost',
    howToSelectSkates: 'Jak vybrat velikost bruslí',
    unavailable: 'Nedostupné',
    inStock: 'Skladem',
    onRequest: 'Na dotaz'

  },

  en: {
  urlporadna: '/en/advice/',
  precistClanek: 'Read article',
  vytvoril: 'Created by',
  textporadna: 'Advice',

  obleceniProZavodText: "FIGURE SKATING APPAREL",
  obleceniProZavodBenefity: "Our own Czech brand Icedream * Competition dresses * Men's collection * World-renowned brands",
  obleceniProZavodBtnText: "View full collection",
  obleceniProZavodBtnOdkaz: "/#/",

  ledniKrasobrusleText: "Figure Skates",
  ledniKrasobrusleBenefity: "Professional figure skates, blades and complete sets for everyone from beginners to elite competitors.",
  ledniKrasobrusleBtnText: "View all products",
  ledniKrasobrusleBtnOdkaz: "/#/",

  telefonInfo: '(MON - FRI 9:00 - 16:00)',
  mailInfo: 'we will reply within 48 hours',

  customLoginText: 'Already have an account? Log in and your details will be filled in automatically.',
  customLoginBtn: 'Log in',

  vybrat: 'Choose from our products',
  pokracovatnaobjednvaku: 'Continue to checkout',
  nepotrebujete: 'Need anything else?',

  produkt: 'Product',
  dostupnost: 'Availability',
  pocet: 'Quantity',
  cenaZaKus: 'Price per item',
  sleva: 'Discount',
  celkem: 'Total',

  odebratkupon: 'Remove coupon',

  objednavkaPrijata: 'Order received',
  dekujemeZaObjednavku: 'Thank you for your order',
  jejiCislo: 'Order number: ',
  zdarma: 'Free',
  darekKObjednavce: 'Free gift with your order',
  zaKus: '/ pc',

  dalsiProdukty: 'More products',
  parametryProduktu: 'Product parameters',
  filtrovat: 'Filter',
  zavritFiltr: 'Close filter',
  nejprodavanejsiVKategorii: 'Best sellers in this category',
  stitky: 'Tags',
  seraditDle: 'Sort by',

  dokosiku: 'Add to cart',
  souvisejicividea: 'Related videos',
  parametry: 'Parameters',
  overenyzakaznik: 'Verified customer',

  urlhodnoceni: '/cache/en/store-rating/?jsonFormat',

  objednatbrouseni: 'Order sharpening:',
  az: 'to',
   choosesizes: 'Choose a Size',
  howToSelectSkates: 'How to Choose Your Skate Size',
  unavailable: 'Unavailable',
  inStock: 'In stock',
  onRequest: 'On request'
},
};

function translation(key) {
  const lang = $('html').attr('lang') || 'cz';
  const parts = key.split('.');
  const requestedLang = parts.length > 1 ? parts[0] : lang;
  const realKey = parts.length > 1 ? parts[1] : parts[0];

  return translations[requestedLang]?.[realKey]
    ?? translations.cz?.[realKey]
    ?? key;
}